import React, { Component } from 'react';
import { Divider } from './common/atoms';
import CustomDrawer from './common/organisms/Drawer';
import HelpDrawerBody from './Others/HelpDrawerBody';
import HelpApi from '../services/help.api';
import handleAppError from './handlers/handleAppError';
import { Redirect } from 'react-router-dom';
import { Man, Help } from '../assets/images';
import appApi from '../services/app.api';
import { Select, Tooltip } from 'antd';
import { upArrow, downArrow } from '../constants/svgCodes';
import { AppDispatchContext } from '../utils/contexts';

const Option = Select.Option;

class NavBar extends Component {
  constructor(props) {

    super(props);}
  static contextType = AppDispatchContext

  state = {
    help_data: null,
    redirect: false,
    showUserProfile: false
  };

  logout = () => {
    appApi.logout({}, this.onSuccess, this.onError);
  };

  onSuccess = (res) => {
    sessionStorage.removeItem('company_id');
    sessionStorage.clear();
    this.setState({ redirect: true });
  };

  onError = (err) => {
    handleAppError(err);
  };

  getHelpData = async () => {
    await HelpApi.help_request(
      {},
      (res) => this.setState({ help_data: res.data }),
      (err) => handleAppError(err)
    );
  };

  toggleUserProfile = () => {
    this.setState({ showUserProfile: !this.state.showUserProfile });
  };

  makeShowProfileFalse = (e) => {
    if (e.target.parentNode?.id !== 'profile')
      this.setState({ showUserProfile: this.state.showUserProfile ? !this.state.showUserProfile : false });
  };

  componentDidMount() {
    this.getHelpData();
    window.addEventListener('click', this.makeShowProfileFalse);
    window.addEventListener("overviewCompaniesChanged", this.handleOverviewCompaniesChange);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.makeShowProfileFalse);
    window.removeEventListener("overviewCompaniesChanged", this.handleOverviewCompaniesChange);
  }

  handleOverviewCompaniesChange = () => {
    const overviewSelectedCompanies = JSON.parse(sessionStorage.getItem("overviewSelectedCompanies") || "[]");
    const companies = JSON.parse(sessionStorage.getItem("companies") || "[]");

    if (overviewSelectedCompanies.length === 1) {
      const selectedCompanyId = overviewSelectedCompanies[0];
      const selectedCompany = companies.find(c => c.id === selectedCompanyId);

      if (selectedCompany) {
        const key = {
          props: {
            companyName: selectedCompany.name,
            isChildCompany: selectedCompany.parent_company_id,
            calendarToken: selectedCompany.calendar_token,
            launchDate: selectedCompany.launch_date
          }
        };
        
        this.handleChange(selectedCompanyId, key);
      }
    }
  };

  handleChange = (value, key) => {
    let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
    let api_url = window.API_URL;
    let cal_url = api_url.replace('/v1/', '');
    window.axios.defaults.headers.common['X-COMPANY-ID'] = value;
    sessionStorage.setItem('company_id', value);
    sessionStorage.setItem('company_name', key.props.companyName);
    sessionStorage.setItem('is_child_company', JSON.stringify(key.props.isChildCompany ?? false));
    sessionStorage.setItem('launch_date', key.props.launchDate);
    this.context({ companyId: parseInt(value, 10) })

    // window.location.pathname = window.location.pathname;
    this.props.getDigitizationFlag();
    this.props.fetchBenefitList();

    const { that } = this.props;
    that.setState({ dummyChild: 'unmount' });
    
    setTimeout(() => {
      that.setState({ dummyChild: '' });
    });
    


    sessionStorage.setItem(
      'calendar_url',
      cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + key.props.calendarToken + '/calendar.ics'
    );
    
  };

  handleBlur() {
    // console.log('blur');
  }

  handleFocus() {
    // console.log('focus');
  }

  showCompany() {
    let companies = JSON.parse(sessionStorage.getItem("companies") || "[]");
    let overviewSelectedCompanies = JSON.parse(sessionStorage.getItem("overviewSelectedCompanies") || "[]");
    let selectedCompany =
      overviewSelectedCompanies.length === 0
        ? parseInt(sessionStorage.getItem("company_id"), 10)
        : overviewSelectedCompanies.length === 1
          ? overviewSelectedCompanies[0]
          : `${overviewSelectedCompanies.length} Companies Selected`;

    if (
      ((this.props.previousState.role===null || this.props.previousState.role===undefined )? " " : this.props.previousState.role.toLowerCase()) === 'broker' ||
      ((this.props.previousState.role===null || this.props.previousState.role===undefined ) ? " " : this.props.previousState.role.toLowerCase()) === 'csm' ||
      ((this.props.previousState.role===null || this.props.previousState.role===undefined )? " " : this.props.previousState.role.toLowerCase()) === 'csmmaster' ||
      ((this.props.previousState.role===null || this.props.previousState.role===undefined )? " " : this.props.previousState.role.toLowerCase()) === 'staff' && companies.length > 1
    )  {
      return (
        <span style={{ paddingLeft: 12 }}>
          <Select
            showSearch
            style={{ width: 250, backgroundColor: '#fff' }}
            value={selectedCompany || undefined}
            placeholder='Select a company'
            optionFilterProp='children'
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            filterOption={(input, option) => {
                const labelText = React.Children.toArray(option.props.children)
                  .filter((child) => typeof child === "string")
                  .join("")
                  .toLowerCase();
                return labelText.includes(input.toLowerCase());
              }}
          >
            {companies.map((key) => {
              return (
                <Option key={key.name} value={key.id} companyName={key.name} isChildCompany={key.parent_company_id} calendarToken={key.calendar_token} launchDate={key.launch_date} >
                  {key.name} <span className='text-xs font-fig-normal'>{(key.enable_spending_account || key.remote_wallet_enabled) ? '(OPD)' : ''}</span>
                </Option>
              );
            })}
          </Select>
        </span>
      );
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/login' />;
    }

    const { showUserProfile } = this.state;
    return (
      <nav className='bg-white border-b fixed z-10 w-full right-0'>
        <div className='ml-64 px-4 sm:px-6 lg:px-8 lg:pl-1'>
          <div className='flex justify-between h-16'>
            <div className='flex justify-start'>
              <div className='flex items-center'>{this.showCompany()}</div>
            </div>
            <div className='hidden sm:ml-6 sm:flex sm:items-center'>
              <div className='flex'>

                {!['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) && (
                  <Tooltip placement='bottom' title='Help'>
                    <button
                      onClick={() => this.props.toggleHelp()}
                      className='ml-12 bg-white rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
                    >
                      <img className='h-10 w-10' src={Help} alt='helpIcon' />
                    </button>
                  </Tooltip>
                )}
              </div>

              <Divider type='vertical' classes='h-7 mr-4 ml-4' />

              <div className='relative'>
                <div id='profile' className='flex items-center cursor-pointer' onClick={this.toggleUserProfile}>
                  <img className='mr-4 rounded-full' src={Man} alt='User Drop down' />
                  <div className='mr-2 text-gray-700 font-semibold'>{sessionStorage.getItem('hr_name')}</div>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='text-gray-600 h-5 w-5'
                    viewBox='0 0 20 20'
                    fill='currentColor'
                  >
                    <path fillRule='evenodd' d={showUserProfile ? upArrow : downArrow} clipRule='evenodd' />
                  </svg>
                </div>
                {showUserProfile && (
                  <div
                    className='z-10 origin-top-right absolute -right-8 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'
                    role='menu'
                    aria-orientation='vertical'
                    aria-labelledby='user-menu'
                  >
                    <a href='#' className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100' role='menuitem'>
                      {sessionStorage.getItem('hr_email')}
                    </a>
                    <a
                      className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                      href='/account-settings'
                      role='menuitem'
                    >
                      Account Settings 
                    </a>
                    <a
                      className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                      onClick={this.logout}
                      role='menuitem'
                    >
                      Sign out
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CustomDrawer
          title='Help'
          body={
            <HelpDrawerBody
              initialKey={this.props.initialKey}
              data={this.state.help_data}
              reset={!this.props.showhelp}
            />
          }
          subHeaderStyle={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#324467',
            display: 'flex',
            justifyContent: 'space-between',
          }}
          visible={this.props.showhelp}
          width='37%'
          headerStyle={{
            backgroundColor: '#F5F7F9',
            height: '61px',
            padding: '19px 24px',
          }}
          close={this.props.toggleHelp}
          className='help-drawer-xs'
        ></CustomDrawer>
      </nav>
    );
  }
}

export default NavBar;
